import { Container } from "../components/container";

const BUCKET_BASE_URL = process.env.BUCKET_BASE_URL || "assets";

export function Contact() {
  return (
    <Container
      className="min-h-dvh flex flex-col !mx-auto !max-w-[770px] pb-[250px] pt-[195px]"
      id="contact"
    >
      <div className="flex w-full gap-5 items-end pt-20">
        <div className="min-w-[50%]">
          <img
            alt="Carin"
            decoding="async"
            loading="lazy"
            src={`${BUCKET_BASE_URL}/images/carin.jpg`}
          />
        </div>
        <div className="min-w-[50%]">
          <p className="mb-5">
            Projektör(AutoCAD & Revit), Illustratör & Debatör
          </p>

          <p className="mb-5">
            Carin Dahlberg
            <br />
            Landskapsarkitekt LAR/MSA
            <br />
            <a href="tel:+46739810924">073-981 09 24</a>
            <br />
            <a href="mailto:carin@eastlandscape.se">carin@eastlandscape.se</a>
          </p>
          <p>
            Org nr: 559516-5134, VAT-nr: SE559516513401
            <br />
            Innehar F-skattebevis, Bankgiro: 796-0990
          </p>
          <Footer className="mt-24 hidden md:block" />
        </div>
      </div>
      <Footer className="mt-5 md:hidden" />
    </Container>
  );
}

function Footer({ className }: { className?: string }) {
  return (
    <div className={className}>
      <p className="mb-5">
        East landscape är alltid intresserad av givande samarbeten och bollar
        gärna ideér på hur vi tillsammans utvecklar våra gemensamma utemiljöer.
      </p>
      <p>Är du med på resan?</p>
    </div>
  );
}
